export const startupTranslation = {
  new_case_header: 7434,
  new_case_description: 7433,
  new_case_register: 5328,

  open_case_header: 8298,
  open_case_description: 8317,
  open_case_case_no: 8299,
  open_case: 8300,

  save_as_draft_info: 9916,
  case_saved_as_draft: 9917,
  follow_up_draft: 9918,

  case_draft_subtitle: 9913,
  case_draft_link_cases: 9914,
  case_draft_link_case: 9915
};
